import app from './main-app'
import VueMatomo from 'vue-matomo'
import 'vue-universal-modal/dist/index.css'
import * as Sentry from "@sentry/vue";
import {localeFilesMixin} from "@/mixins/localeFilesMixin";
import './style-scirt.scss'
import {getScreens} from "@/screens-scirt";
import {getProject, setProject} from "@/hooks/state";

setProject('SCIRT')

if (process.env.NODE_ENV === 'production') {
    console.log('Sentry init');
    Sentry.init({
        app,
        dsn: "https://bb194a401db142cbb7d24e3127b4bb03@o405761.ingest.sentry.io/4504180301758464",
        integrations: [
            new Sentry.BrowserTracing({})
        ],
        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 1.0,
        environment: getProject(),
        beforeSend: (event, hint) => {
            console.error(hint.originalException, hint.syntheticException, event);

            return event;
        }
    });
}

app.mixin(localeFilesMixin)
app.use(VueMatomo, {
    // Configure your matomo server and site by providing
    host: 'https://analytics.prospex-institute.org',
    siteId: 3,

    // Changes the default .js and .php endpoint's filename
    // Default: 'matomo'
    // trackerFileName: 'matomo',

    // Overrides the autogenerated tracker endpoint entirely
    // Default: undefined
    // trackerUrl: 'https://example.com/whatever/endpoint/you/have',

    // Overrides the autogenerated tracker script path entirely
    // Default: undefined
    // trackerScriptUrl: 'https://example.com/whatever/script/path/you/have',

    // Enables automatically registering pageviews on the router
    // router: router,

    // Enables link tracking on regular links. Note that this won't
    // work for routing links (ie. internal Vue router links)
    // Default: true
    enableLinkTracking: true,

    // Require consent before sending tracking information to matomo
    // Default: false
    requireConsent: false,

    // Whether to track the initial page view
    // Default: true
    trackInitialView: true,

    // Run Matomo without cookies
    // Default: false
    disableCookies: true,

    // Require consent before creating matomo session cookie
    // Default: false
    requireCookieConsent: false,

    // Enable the heartbeat timer (https://developer.matomo.org/guides/tracking-javascript-guide#accurately-measure-the-time-spent-on-each-page)
    // Default: false
    enableHeartBeatTimer: true,

    // Set the heartbeat timer interval
    // Default: 15
    heartBeatTimerInterval: 60,

    // Whether or not to log debug information
    // Default: false
    debug: true,

    // UserID passed to Matomo (see https://developer.matomo.org/guides/tracking-javascript-guide#user-id)
    // Default: undefined
    userId: undefined,

    // Share the tracking cookie across subdomains (see https://developer.matomo.org/guides/tracking-javascript-guide#measuring-domains-andor-sub-domains)
    // Default: undefined, example '*.example.com'
    cookieDomain: undefined,

    // Tell Matomo the website domain so that clicks on these domains are not tracked as 'Outlinks'
    // Default: undefined, example: '*.example.com'
    domains: undefined,

    // A list of pre-initialization actions that run before matomo is loaded
    // Default: []
    // Example: [
    //   ['API_method_name', parameter_list],
    //   ['setCustomVariable','1','VisitorType','Member'],
    //   ['appendToTrackingUrl', 'new_visit=1'],
    //   etc.
    // ]
    preInitActions: [],

    // A function to determine whether to track an interaction as a site search
    // instead of as a page view. If not a function, all interactions will be
    // tracked as page views. Receives the new route as an argument, and
    // returns either an object of keyword, category (optional) and resultsCount
    // (optional) to track as a site search, or a falsey value to track as a page
    // view.
    // Default: false, i.e. track all interactions as page views
    // Example: (to) => {
    //   if (to.query.q && to.name === 'search') {
    //     return { keyword: to.query.q, category: to.params.category }
    //   } else {
    //    return null
    //   }
    // }
    trackSiteSearch: (to) => {
        if (to.query.q && to.name === 'search') {
            return {keyword: to.query.q, category: to.params.category}
        } else {
            return null
        }
    }
})

app.mixin({
    methods: {
        getScreenConfig(tranFn, state, locale) {
            return getScreens(tranFn, state, locale);
        }
    }
})

app.mount('#app')
